
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/market-conduct/bulletin",
      function () {
        return require("private-next-pages/compliance/market-conduct/bulletin/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/market-conduct/bulletin"])
      });
    }
  